import { HTMLAttributes } from 'react'

import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'

type SingleParagraphProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    paragraph: string
    link: {
      url: string
      title: string
      target: string
    }
  }>

const SingleParagraph = ({
  title,
  paragraph,
  link,
  className
}: SingleParagraphProps) => {
  return (
    <div
      className={cn('px-[3rem] md:px-[10rem]', className)}
      data-single-paragraph
    >
      <div className="relative flex flex-col gap-[2rem]">
        {link?.url ? (
          <a
            href={link.url}
            target={link.target}
            rel="noopener noreferrer"
            className="contents"
          >
            <div className="flex flex-col items-center justify-center gap-[2rem]">
              {title ? (
                <Typography
                  component="h2"
                  className="text-center text-[3.8rem] font-light leading-[1]"
                >
                  {title}
                </Typography>
              ) : null}
              {paragraph ? (
                <Typography
                  component="p"
                  className="text-center text-[2.5rem] font-light leading-[1.5] md:text-[3.2rem]"
                >
                  {paragraph}
                </Typography>
              ) : null}
              <Typography component="p" className="button">
                {link.title}
              </Typography>
            </div>
          </a>
        ) : (
          <>
            <div className="flex flex-col items-center justify-center gap-[2rem]">
              {title ? (
                <Typography
                  component="h2"
                  className="text-center text-[3.8rem] font-light leading-[1]"
                >
                  {title}
                </Typography>
              ) : null}
              {paragraph ? (
                <Typography
                  component="p"
                  className="text-center text-[2.5rem] font-light leading-[1.5] md:text-[3.2rem]"
                >
                  {paragraph}
                </Typography>
              ) : null}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default SingleParagraph
